var _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtcsVaultLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 58,
    viewBox: "0 0 250 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.602 18.15H185.87L192.214 37H197.414L203.81 18.15H199.286L194.944 32.008L190.602 18.15ZM211.932 27.718V28.264C206.498 28.654 202.624 29.798 202.624 33.23C202.624 35.778 204.808 37.338 207.46 37.338C209.462 37.338 211.126 36.792 212.166 35.31L212.218 37H216.43C216.17 35.804 216.092 33.308 216.118 31.488L216.17 28.446C216.248 24.182 213.934 22.57 209.93 22.57C205.796 22.57 203.248 24.91 203.066 27.536H207.07C207.226 26.184 208.188 25.482 209.566 25.482C211.1 25.482 211.932 26.08 211.932 27.718ZM207.044 32.918C207.044 31.436 209.046 31.046 212.036 30.786V31.124C212.036 33.698 210.736 34.426 209.02 34.426C207.902 34.426 207.044 33.828 207.044 32.918ZM227.143 35.05V37H231.433V23.012H227.143V30.396C227.143 32.97 226.441 34.01 224.621 34.01C222.541 34.01 222.489 32.372 222.489 30.37V23.012H218.199V31.436C218.199 35.232 219.317 37.338 223.035 37.338C225.193 37.338 226.285 36.428 227.143 35.05ZM238.416 37V18.15H234.126V37H238.416ZM241.759 19.19V23.012H239.549V26.054H241.759V33.074C241.759 36.35 242.955 37 246.387 37H249.117V33.906H247.895C246.465 33.906 246.049 33.646 246.049 32.32V26.054H249.117V23.012H246.049V19.19H241.759Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 0.5V57.5",
    stroke: "#262626",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.472 8.53825C125.414 8.53825 126.27 7.9349 126.27 7.04424C126.27 6.09611 125.442 5.4353 124.472 5.4353C123.474 5.4353 122.703 6.09611 122.703 7.04424C122.703 7.9349 123.474 8.53825 124.472 8.53825",
    fill: "#262626"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.103,
    y: 11.4114,
    width: 2.68184,
    height: 12.0383,
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.999 11.0952C134.23 11.0952 132.832 11.5836 131.491 12.9053L128.98 11.4113V23.4495H131.662V15.606C132.489 14.3418 133.973 13.4512 135.228 13.4512C137.197 13.4512 137.967 14.1694 137.967 16.9851V23.4495H140.592V16.4392C140.592 12.7903 138.88 11.0952 135.999 11.0952",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.162 23.6794C103.645 23.6794 105.072 23.4495 106.213 22.9611V20.5764C104.615 21.3522 103.588 21.5246 102.476 21.5246C100.393 21.5246 97.9677 20.088 97.9677 17.4448C97.9677 14.6291 100.108 13.365 102.476 13.365C103.56 13.365 104.844 13.5948 105.985 14.2556V11.8135C104.986 11.3251 103.731 11.0952 102.647 11.0952C98.3672 11.0952 95.2003 13.681 95.2003 17.3298C95.2003 21.7544 98.9092 23.6794 102.162 23.6794",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.735 17.3873C120.735 21.1511 117.996 23.6794 114.002 23.6794C110.093 23.6794 107.297 21.1798 107.269 17.3873C107.269 13.6235 110.093 11.0952 114.002 11.0952C117.996 11.0952 120.735 13.6235 120.735 17.3873ZM118.053 17.416C118.053 14.9452 116.455 13.4512 114.002 13.4512C111.577 13.4512 110.007 15.0026 110.007 17.416C110.007 19.8869 111.577 21.3809 114.002 21.3809C116.455 21.3809 118.053 19.8007 118.053 17.416Z",
    fill: "#262626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4501,
    y: 11.4114,
    width: 2.68182,
    height: 12.0383,
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0308 14.7442C75.3432 13.911 76.5986 12.5894 76.5986 10.7794C76.5986 8.39468 74.8867 6.64209 71.1208 6.64209H64.1594V23.421H71.2919C75.0294 23.421 77.5401 21.8121 77.5401 18.5655C77.5401 16.5543 76.2277 15.2901 74.0308 14.7442ZM66.7271 9.05549H70.5787C72.4902 9.05549 73.7455 9.88869 73.7455 11.4402C73.7455 13.1066 72.4331 13.9685 70.7784 13.9685H66.7271V9.05549ZM66.7271 20.9789H71.1778C73.6885 20.9789 74.687 19.9733 74.687 18.4505C74.687 16.7841 73.4317 16.1233 70.5787 16.1233H66.7271V20.9789Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6597 21.3523C93.1176 21.4672 92.5185 21.5247 92.062 21.5247C91.1205 21.5247 90.4072 21.1799 90.4072 19.8583V13.4513H93.5741V11.4114H90.3787V8.33716L87.6968 8.62447V11.3826H85.6712V13.4225H87.6968V20.2031C87.6968 22.5877 89.0663 23.7944 91.149 23.7944C91.634 23.7944 92.5755 23.7944 93.6597 23.4497V21.3523V21.3523Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7625 8.53825C82.7611 8.53825 83.5314 7.9349 83.5314 7.04424C83.5314 6.09611 82.7611 5.4353 81.7625 5.4353C80.8211 5.4353 79.9651 6.09611 79.9651 7.04424C79.9937 7.9349 80.8211 8.53825 81.7625 8.53825",
    fill: "#262626"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.923 41.6175C101.923 40.6558 103.181 40.3352 104.553 40.3352C106.211 40.3352 108.241 40.8889 109.156 41.4426V39.0238C107.955 38.4701 106.183 38.1204 104.553 38.1204C101.466 38.1204 99.1212 39.0238 99.1212 41.8215C99.1212 43.774 100.608 44.8523 103.839 45.4643C105.497 45.7558 107.069 46.018 107.069 47.1546C107.069 48.3786 105.868 48.6117 104.439 48.6117C102.638 48.6117 100.379 47.9997 99.4929 47.5043V49.9232C100.636 50.4186 102.466 50.8266 104.325 50.8266C107.184 50.8266 109.928 49.9232 109.928 46.8632C109.9 42.6375 101.923 44.0363 101.923 41.6175",
    fill: "#262626"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.337 44.4153C123.337 40.6559 126.367 38.0913 129.941 38.0913C133.743 38.0913 135.888 40.685 135.916 44.0073C135.916 44.561 135.916 45.0273 135.859 45.4644H126.139C126.31 47.4461 128.654 48.6118 130.856 48.6118C132.285 48.6118 133.658 48.3787 135.144 47.5919V49.9524C133.829 50.6227 132.028 50.8558 130.313 50.8558C126.196 50.8558 123.337 48.2913 123.337 44.4153ZM129.941 40.2187C128.111 40.2187 126.424 41.4136 126.139 43.3661H133.286C133.029 41.2679 131.542 40.2187 129.941 40.2187Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1186 32.321C94.1752 32.321 93.3461 32.9913 93.3461 33.953C93.3461 34.8565 94.1752 35.4685 95.1186 35.4685C96.0621 35.4685 96.9198 34.8565 96.9198 33.953C96.9198 32.9913 96.0907 32.321 95.1186 32.321",
    fill: "#262626"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7425 46.3971C86.9706 47.621 85.4267 48.641 84.1116 48.641C82.1961 48.641 81.5385 47.7376 81.5385 44.9982V38.3828H78.8511V45.6102C78.8511 48.5245 79.6802 50.9433 83.0824 50.9433C84.569 50.9433 86.1129 50.7685 87.7997 49.1948L87.9712 50.5936H90.4013V38.3828H87.7139V46.3971H87.7425Z",
    fill: "#262626"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9889 41.1221C67.7011 40.277 66.4717 39.6067 66.4717 38.033C66.4717 36.6924 67.5581 35.789 69.5022 35.789C71.2462 35.789 73.2475 36.4593 75.0486 37.5667V34.5942C73.5048 33.749 71.5321 33.1953 69.5022 33.1953C65.9857 33.1953 63.4126 34.973 63.4126 38.3536C63.4126 41.705 65.8999 42.4918 69.2449 43.337C72.6471 44.1821 73.4762 44.9107 73.4762 46.193C73.4762 47.7084 72.2182 48.437 70.1884 48.437C67.987 48.437 65.6712 47.5918 63.6985 46.3095V49.3987C65.2995 50.4187 68.2157 51.0307 70.1312 51.0307C73.8764 51.0307 76.5067 49.6318 76.5067 45.8141C76.5353 43.0164 74.3911 42.0256 70.9889 41.1221",
    fill: "#262626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.8321,
    y: 38.3828,
    width: 2.68745,
    height: 12.2108,
    fill: "#262626"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.016 41.6175C114.016 40.6558 115.274 40.3352 116.647 40.3352C118.305 40.3352 120.335 40.8889 121.25 41.4426V39.0238C120.049 38.4701 118.276 38.1204 116.647 38.1204C113.559 38.1204 111.215 39.0238 111.215 41.8215C111.215 43.774 112.701 44.8523 115.932 45.4643C117.59 45.7558 119.163 46.018 119.163 47.1546C119.163 48.3786 117.962 48.6117 116.532 48.6117C114.731 48.6117 112.473 47.9997 111.586 47.5043V49.9232C112.73 50.4186 114.56 50.8266 116.418 50.8266C119.277 50.8266 122.022 49.9232 122.022 46.8632C122.022 42.6375 114.016 44.0363 114.016 41.6175",
    fill: "#262626"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2161 11.1982H26.8356V24.6146H38.5457C40.9034 24.6618 42.7234 24.532 44.0824 24.1869L44.4463 24.0944L44.7742 23.9109C46.7395 22.8108 47.5817 21.9987 48.5386 20.2512C48.6543 20.0399 48.7602 19.8242 48.8567 19.6045C49.2255 18.7651 49.447 17.8983 49.5594 17.009C49.6298 16.4523 49.6488 16.0295 49.6495 15.4623L49.6496 15.2456L49.6506 15.1665C49.657 14.6812 49.6482 14.2583 49.6054 13.7375C49.5416 12.9591 49.4126 12.1945 49.1948 11.4493C48.9434 10.5888 48.5841 9.79277 48.088 9.08018C47.1344 7.71057 46.2834 6.99335 44.7174 6.21049L44.6239 6.16407L44.603 6.15417C43.2289 5.50245 41.2847 5.32443 38.5095 5.44928H32.5597V0.968994H26.8356V5.44928H19.2161V0.968994H13.492V5.44928H0.157654V24.6146H19.2161V11.1982ZM13.492 11.1982V18.8657H5.88174V11.1982H13.492ZM32.5597 11.1982V18.8657H38.604L38.7233 18.8681C40.3357 18.8979 41.5607 18.8286 42.35 18.6842C42.9761 18.3233 43.1263 18.1803 43.3918 17.7165L43.4466 17.6193L43.5229 17.4809C43.5575 17.4178 43.5897 17.3521 43.6198 17.2837C43.8572 16.7432 43.9272 16.19 43.9254 15.3733L43.9253 15.2869L43.9279 15.0017C43.9323 14.2912 43.8756 13.6609 43.7024 13.0682C43.6156 12.7713 43.5096 12.5364 43.3969 12.3745C43.0537 11.8815 42.9251 11.7473 42.389 11.4694L42.2707 11.409L42.1476 11.3475C41.8588 11.2215 40.7494 11.1193 39.0341 11.1815L38.8386 11.1892L38.6408 11.1982H32.5597Z",
    fill: "#CF0A2C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.843 45.7584V32.342H38.5531C40.9109 32.2948 42.7309 32.4246 44.0899 32.7697L44.4538 32.8621L44.7816 33.0456L44.9154 33.1211L45.0457 33.1957C46.8246 34.2224 47.6331 35.0382 48.546 36.7053C48.6617 36.9167 48.7676 37.1324 48.8641 37.352C49.233 38.1915 49.4544 39.0582 49.5669 39.9475C49.6373 40.5042 49.6562 40.9271 49.657 41.4943L49.657 41.7109L49.6581 41.79C49.6644 42.2753 49.6556 42.6982 49.6129 43.219C49.549 43.9975 49.42 44.7621 49.2023 45.5073C48.9508 46.3678 48.5915 47.1638 48.0954 47.8764C47.1565 49.2249 46.3171 49.941 44.7966 50.71L44.6313 50.7925L44.6104 50.8024C43.2364 51.4541 41.2921 51.6321 38.5169 51.5073H32.5671V55.9875H26.843V51.5073H19.2235V55.9875H13.4994V51.5073H0.1651V32.342H19.2235V45.7584H26.843ZM13.4994 38.0908H5.88919V45.7584H13.4994V38.0908ZM32.5671 45.7584V38.0908H38.6114L38.8199 38.0869C40.2688 38.0632 41.3985 38.1206 42.173 38.2412L42.2679 38.2566L42.3574 38.2723C42.9701 38.6255 43.1271 38.77 43.3823 39.2107L43.4361 39.3051L43.5304 39.4756C43.5649 39.5387 43.5972 39.6045 43.6272 39.6729C43.8647 40.2133 43.9346 40.7666 43.9329 41.5833L43.9327 41.6696L43.9353 41.9548C43.9397 42.6653 43.883 43.2957 43.7098 43.8884C43.6231 44.1853 43.5171 44.4201 43.4043 44.582C43.0606 45.0757 42.9322 45.2096 42.3943 45.4883L42.3165 45.5282L42.155 45.6091C41.8663 45.7351 40.7569 45.8373 39.0415 45.775L38.846 45.7673L38.6483 45.7584H32.5671Z",
    fill: "#CF0A2C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4947 45.7178V51.5045H6.10254V45.7178H13.4947Z",
    fill: "url(#paint0_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8269 45.7178V51.5045H22.0689V45.7178H26.8269Z",
    fill: "url(#paint1_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2273 51.5045V45.7178H23.9853V51.5045H19.2273Z",
    fill: "url(#paint2_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.599 51.5045V45.7178H39.9911V51.5045H32.599Z",
    fill: "url(#paint3_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.465 11.2158H19.2306V18.6483H13.465V11.2158Z",
    fill: "url(#paint4_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8334 11.186H32.5661V18.6185H26.8334V11.186Z",
    fill: "url(#paint5_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.47,
    x: 26.8005,
    y: 0.974365,
    width: 5.79847,
    height: 4.46146,
    fill: "url(#paint6_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.47,
    x: 13.465,
    y: 1.13965,
    width: 5.76554,
    height: 4.29623,
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.10325,
    y1: 51.5049,
    x2: 13.4943,
    y2: 51.5049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CA0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0512942,
    stopColor: "#8E9194",
    stopOpacity: 0.0425742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2635,
    stopColor: "#64666A",
    stopOpacity: 0.2187
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    stopColor: "#424549",
    stopOpacity: 0.3899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#2A2D31",
    stopOpacity: 0.5525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    stopColor: "#1C1F23",
    stopOpacity: 0.7031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.0688,
    y1: 51.5055,
    x2: 26.8271,
    y2: 51.5055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CA0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0512942,
    stopColor: "#8E9194",
    stopOpacity: 0.0425742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2635,
    stopColor: "#64666A",
    stopOpacity: 0.2187
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    stopColor: "#424549",
    stopOpacity: 0.3899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#2A2D31",
    stopOpacity: 0.5525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    stopColor: "#1C1F23",
    stopOpacity: 0.7031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.9868,
    y1: 45.7185,
    x2: 19.2286,
    y2: 45.7185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CA0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0512942,
    stopColor: "#8E9194",
    stopOpacity: 0.0425742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2635,
    stopColor: "#64666A",
    stopOpacity: 0.2187
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    stopColor: "#424549",
    stopOpacity: 0.3899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#2A2D31",
    stopOpacity: 0.5525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    stopColor: "#1C1F23",
    stopOpacity: 0.7031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 39.9911,
    y1: 45.7191,
    x2: 32.6001,
    y2: 45.7191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CA0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0512942,
    stopColor: "#8E9194",
    stopOpacity: 0.0425742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2635,
    stopColor: "#64666A",
    stopOpacity: 0.2187
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    stopColor: "#424549",
    stopOpacity: 0.3899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#2A2D31",
    stopOpacity: 0.5525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    stopColor: "#1C1F23",
    stopOpacity: 0.7031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.2299,
    y1: 18.6499,
    x2: 19.2299,
    y2: 11.2166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CA0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0512942,
    stopColor: "#8E9194",
    stopOpacity: 0.0425742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2635,
    stopColor: "#64666A",
    stopOpacity: 0.2187
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    stopColor: "#424549",
    stopOpacity: 0.3899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#2A2D31",
    stopOpacity: 0.5525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    stopColor: "#1C1F23",
    stopOpacity: 0.7031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 32.5655,
    y1: 18.6201,
    x2: 32.5655,
    y2: 11.1869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9CA0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0512942,
    stopColor: "#8E9194",
    stopOpacity: 0.0425742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2635,
    stopColor: "#64666A",
    stopOpacity: 0.2187
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    stopColor: "#424549",
    stopOpacity: 0.3899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    stopColor: "#2A2D31",
    stopOpacity: 0.5525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    stopColor: "#1C1F23",
    stopOpacity: 0.7031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 26.7998,
    y1: 0.974365,
    x2: 26.7998,
    y2: 5.43566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000600962,
    stopColor: "#9A9CA0",
    stopOpacity: 0.1096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518643,
    stopColor: "#8E9194",
    stopOpacity: 0.1466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#64666A",
    stopOpacity: 0.2995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4701,
    stopColor: "#424549",
    stopOpacity: 0.448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6659,
    stopColor: "#2A2D31",
    stopOpacity: 0.5892
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8473,
    stopColor: "#1C1F23",
    stopOpacity: 0.7199
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 13.4642,
    y1: 1.13965,
    x2: 13.4642,
    y2: 5.43572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000600962,
    stopColor: "#9A9CA0",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518643,
    stopColor: "#8E9194",
    stopOpacity: 0.1469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#64666A",
    stopOpacity: 0.2997
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4701,
    stopColor: "#424549",
    stopOpacity: 0.4482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6659,
    stopColor: "#2A2D31",
    stopOpacity: 0.5893
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8473,
    stopColor: "#1C1F23",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A1E",
    stopOpacity: 0.83
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcsVaultLogo);
export default __webpack_public_path__ + "static/media/btcs-vault-logo.068d2f509bc9546c7a4895fc3a775b5d.svg";
export { ForwardRef as ReactComponent };